import React, { Fragment } from "react";
import { Row, Col, Card, CardBody, Button, Badge, Table } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../api/api";
import { useAdmin } from "../../../context/AdminContext";

const ProductDetails = ({ product }) => {
  const navigate = useNavigate();
  const { admin } = useAdmin();

  if (!product) {
    return (
      <div className="text-center py-5">
        <h5>No se encontró el producto.</h5>
      </div>
    );
  }

  const mainImageUrl =
    product.images?.[product.mainImage] !== undefined
      ? `${API_BASE_URL}/product/get/file/${product.images[product.mainImage]}`
      : null;

  return (
    <Fragment>
      <Col xxl="8" className="mx-auto">
        <Card className="shadow-sm">
          <CardBody>
            {/* Título */}
            <h2 className="mb-3 fw-bold">{product.title}</h2>

            {/* Estado */}
            <Badge color={product.status ? "success" : "danger"} className="mb-3">
              {product.status ? "Activo" : "Inactivo"}
            </Badge>

            {/* Imagen Principal */}
            {mainImageUrl && (
              <div className="mb-4 text-center">
                <img
                  src={mainImageUrl}
                  alt="Imagen principal"
                  style={{ maxWidth: "100%", maxHeight: 300, objectFit: "cover", borderRadius: 10 }}
                />
              </div>
            )}

            {/* Short Description */}
            <div className="mb-4">
              <h5 className="text-muted">Descripción corta:</h5>
              <p>{product.shortDescription || "-"}</p>
            </div>
            <div className="mb-4">
              <h5 className="text-muted">Descripción larga:</h5>
              <p>{product.longDescription || "-"}</p>
            </div>

            <div className="mb-4">
              <h5 className="text-muted">Precios por país:</h5>

              {product.aditionalData && product.aditionalData.length > 0 ? (
                <Table responsive bordered striped size="sm" className="mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>País</th>
                      <th>Precio Local</th>
                      <th>USDT</th>
                      <th>Días Entrega</th>
                      <th>Regalía</th>
                      <th>Bono</th>
                    </tr>
                  </thead>
                  <tbody>
                    {product.aditionalData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.country_id?.name ?? "País desconocido"}</td>
                        <td>${item.price_local_currency.toLocaleString()}</td>
                        <td>{item.price_usdt} USDT</td>
                        <td>{item.delivery_time_days} días</td>
                        <td>{item.loyalty_points}</td>
                        <td>{item.influencer_bonus}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-muted">No hay precios registrados.</p>
              )}
            </div>


            <div className="mb-4">
              <h5 className="text-muted">Fechas:</h5>
              <p><strong>Creado:</strong> {new Date(product.createdAt).toLocaleString()}</p>
              <p><strong>Actualizado:</strong> {new Date(product.updatedAt).toLocaleString()}</p>
            </div>

            {/* Acciones */}
            <Row className="mt-4">
              <Col>
                <Button
                  color="primary"
                  onClick={() => navigate(`/product/edit/${product.id}`)}
                  disabled={admin?.role === "ASSISTANT"}
                >
                  <i className="fa fa-edit me-2"></i> Editar Producto
                </Button>
              </Col>
              <Col className="text-end">
                <Button
                  color="secondary"
                  onClick={() => navigate("/product")}
                >
                  <i className="fa fa-arrow-left me-2"></i> Volver a la lista
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default ProductDetails;
